import React, { useState, useEffect } from 'react';
import constant from '../../constant';
import { v2_ships } from '../../actions/v2/projectAndVessel';
import { toast } from 'react-toastify';
import { v2_categories, v2_channels, v2_plan_type } from '../../actions/v2/masterData';
import { v3_upload_plan_approval_document } from '../../actions/v3/planApproval';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { uploadSelectedFiles } from '../../utils/multipleFileUpload';

const CreatePlanApprovalForm = ({ projectId, onSubmit }) => {
    const [state, setState] = useState({
        planName: { name: 'planName', value: '', isRequired: true, error: '' },
        planNumber: { name: 'planNumber', value: '', isRequired: true, error: '' },
        hullId: { name: 'hullId', value: '', options: [], isRequired: true, error: '' },
        yardId: { name: 'yardId', value: '', isRequired: true, error: '' },
        ownerId: { name: 'ownerId', value: '', isRequired: true, error: '' },
        channelId: { name: 'channelId', value: '', isRequired: true, error: '' },
        categoryId: { name: 'categoryId', value: '', options: [], isRequired: true, error: '' },
        typeId: { name: 'typeId', value: '', isRequired: true, error: '' },
        remark: { name: 'remark', value: '', isRequired: false, error: '' },
        documentFiles: { name: 'documentFiles', value: [{ fileName: '', originalFileName: '' }], isRequired: false, error: '' },
    });

    useEffect(() => {
        v2_ships(null, projectId, null).then((res) => {
            if (res.status) {
                if (res.status) {
                    setState(prev => ({
                        ...prev,
                        hullId: {
                            ...prev.hullId,
                            options: res.result.map((item) => {
                                return {
                                    ...item,
                                    id: item.ID,
                                    name: item.HULL_NUMBER + ' - ' + item.SHIP_NAME
                                }
                            }) || []
                        }
                    }))
                }
            }
            else {
                toast.error(res.error || res.error.message)

            }
        })

        v2_categories().then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ['categoryId']: {
                        ...prev['categoryId'],
                        options: res.result.map((item) => {
                            return {
                                id: item.ID,
                                name: item.CATEGORY_NAME
                            }
                        }) || []
                    }
                }));
            }
        })

        v2_plan_type().then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ['typeId']: {
                        ...prev['typeId'],
                        options: res.result.map((item) => {
                            return {
                                id: item.ID,
                                name: item.PLAN_TYPE
                            }
                        }) || []
                    }
                }));
            }
        })

        v2_channels().then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ['channelId']: {
                        ...prev['channelId'],
                        options: res.result.map((item) => {
                            return {
                                id: item.ID,
                                name: item.CHANNEL_NAME
                            }
                        }) || []
                    }
                }));
            }
        })
    }, [])

    useEffect(() => {
        if (state.hullId.value) {
            // Find the selected item from options
            const selectedHull = state.hullId.options.find(
                (item) => item.id == state.hullId.value
            );
            if (selectedHull) {
                const owner = selectedHull.OWNER_NAME;
                const yard = selectedHull.YARD_NAME;
                setState(prev => ({
                    ...prev,
                    ['ownerId']: {
                        ...prev['ownerId'],
                        value: owner,
                    },
                    ['yardId']: {
                        ...prev['yardId'],
                        value: yard,
                    }
                }));
            }
        }
    }, [state.hullId.value, state.hullId.options]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prev => ({
            ...prev,
            [name]: { ...prev[name], value, error: '' }
        }));
    };

    const renderInput = (label, name, placeholder = '') => (
        <div className="col-md-6 mb-3" key={name}>
            <label>{label} {state[name].isRequired ? <span className='text-danger'>*</span> : ''}</label>
            <input
                type="text"
                name={name}
                value={state[name].value}
                placeholder={placeholder}
                onChange={handleChange}
                className={`form-control ${state[name].error ? 'is-invalid' : ''}`}
            />
            {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
        </div>
    );

    const renderSelect = (label, name, options = []) => (
        <div className="col-md-6 mb-3" key={name}>
            <label>{label} {state[name].isRequired ? <span className='text-danger'>*</span> : ''}</label>
            <select
                name={name}
                value={state[name].value}
                onChange={handleChange}
                className={`form-control ${state[name].error ? 'is-invalid' : ''}`}
            >
                <option value="">Select {label}</option>
                {options.map(opt => (
                    <option key={opt.id} value={opt.id}>{opt.name}</option>
                ))}
            </select>
            {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
        </div>
    );
    const handleSubmit = async (e) => {
        e.preventDefault();

        // 1. Validate required fields
        let isValid = true;
        const updatedState = { ...state };

        Object.keys(state).forEach((key) => {
            if (state[key].isRequired && !state[key].value) {
                updatedState[key].error = 'This field is required';
                isValid = false;
            }
        });

        setState(updatedState);
        if (!isValid) {
            toast.error('Please fill all required fields.');
            return;
        }

        // 2. Build payload
        const payload = {
            projectId,
            planName: state.planName.value,
            planNumber: state.planNumber.value,
            hullId: state.hullId.value,
            yardId: state.yardId.value,
            ownerId: state.ownerId.value,
            channelId: state.channelId.value,
            categoryId: state.categoryId.value,
            typeId: state.typeId.value,
            remarks: state.remark.value,
            documentFiles: state.documentFiles.value,
        };

        onSubmit(payload)
    };


    const handleFileChange = async (index, files) => {
        const uploadedFiles = await uploadSelectedFiles(files, v3_upload_plan_approval_document);
        if (!uploadedFiles.length) return;

        setState(prev => {
            const updatedFiles = [...prev.documentFiles.value];
            updatedFiles.splice(index, 1, ...uploadedFiles);
            return {
                ...prev,
                documentFiles: { ...prev.documentFiles, value: updatedFiles, error: '' }
            };
        });
    };

    const addFileField = () => {
        setState(prev => ({
            ...prev,
            documentFiles: {
                ...prev.documentFiles,
                value: [...prev.documentFiles.value, { fileName: '', originalFileName: '' }],
                error: ''
            }
        }));
    };

    const removeFileField = (index) => {
        const updatedFiles = state.documentFiles.value.filter((_, i) => i !== index);
        setState(prev => ({
            ...prev,
            documentFiles: {
                ...prev.documentFiles,
                value: updatedFiles,
                error: updatedFiles.length === 0 ? 'At least one document is required' : ''
            }
        }));
    };
    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                {renderInput('Plan Name', 'planName', 'Enter Plan Name')}
                {renderInput('Plan Number', 'planNumber', 'Enter Plan Number')}
                {renderSelect('Hull', 'hullId', state.hullId.options)}
                {renderInput('Yard', 'yardId', 'Autofill')}
                {renderInput('Owner', 'ownerId', 'Autofill')}
                {renderSelect('Channel', 'channelId', state.channelId.options)}
                {renderSelect('Category', 'categoryId', state.categoryId.options)}
                {renderSelect('Type', 'typeId', state.typeId.options)}



                <div className="col-md-12 mb-3">
                    <label>Upload Documents</label>

                    {state.documentFiles.value.map((item, index) => (
                        <div key={index} className="d-flex align-items-center mb-2">
                            {item.fileName ? (
                                <>
                                    <div className="me-2 flex-grow-1">
                                        <span>{item.originalFileName}</span>
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-outline-danger"
                                        onClick={() => removeFileField(index)}
                                    >
                                        <FaTrash />
                                    </button>
                                </>
                            ) : (
                                <>
                                    <input
                                        type="file"
                                        multiple
                                        onChange={(e) => handleFileChange(index, e.target.files)}
                                        className="form-control me-2"
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-outline-danger"
                                        onClick={() => removeFileField(index)}
                                    >
                                        <FaTrash />
                                    </button>
                                </>
                            )}
                        </div>
                    ))}
                    {/* Add button always visible below the list */}
                    <div>
                        <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={addFileField}
                        >
                            <FaPlus className="me-1" /> Add Document
                        </button>
                    </div>

                    {state.documentFiles.error && (
                        <div className="text-danger mt-1">{state.documentFiles.error}</div>
                    )}
                </div>
                <div className="col-md-12 mb-3">
                    <label>Remarks</label>
                    <textarea
                        row='2'
                        name={'remark'}
                        placeholder='Enter Remarks'
                        value={state['remark'].value}
                        onChange={handleChange}
                        className={`form-control ${state['remark'].error ? 'is-invalid' : ''}`}
                    />
                    {state['remark'].error && <div className="invalid-feedback">{state['remark'].error}</div>}
                </div>
            </div>

            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Submit</button>
                <a className="btn btn-danger text-white" href={constant.Authedcomponent.dashboard.url}>Cancel</a>
            </div>
        </form>
    );
};

export default CreatePlanApprovalForm;
